//hexagon map
import React, { useEffect, useRef } from 'react';
import createHexagon from 'components/ui/HexagonMap/hexagon';

// Check if window is defined (so if in the browser or in node.js).
const isBrowser = typeof window !== 'undefined';

const StatisticsHexagonMap = ({ usStateData, usStateMatrix, ...rest }) => {
  const container = useRef();

  // hexagon shape variables
  let hex_di = 100,
    // radius
    hex_rad = hex_di / 2,
    // apothem
    hex_apo = hex_rad * Math.cos(Math.PI / 6),
    // rows we'll generate
    rows = usStateMatrix.length,
    // columns we'll generate
    cols = usStateMatrix[0].length,
    // stroke width around hexagon
    stroke = 4,
    // the hover state zoom scale
    scale = 2,
    // initial x
    x = (hex_rad * scale) / 2 + stroke * scale,
    // initial y
    y = hex_rad * scale + stroke * scale,
    // side length in pixels
    side = Math.sin(Math.PI / 6) * hex_rad,
    // height of map in pixels
    height = (hex_di - side) * rows + side + hex_rad * scale + stroke * scale,
    // width of map in pixels
    width = hex_apo * 2 * cols + hex_rad * scale + stroke * scale,
    // add text element
    displayPercent = true;

  if (isBrowser) {
    // creating base svg
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var previousElement = null;
    var currentElement = null;

    // svg attributes
    svg.setAttribute('class', 'svg bg-white');
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', '100%');
    svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);

    // loop variables
    let offset = false;
    // initial state index
    let state_index = 0;

    // draw grid
    for (let i = 0; i < usStateMatrix.length; i++) {
      let loop_x = offset ? hex_apo * 2 : hex_apo;

      let loc_x = x;
      for (let s = 0; s < usStateMatrix[i].length; s++) {
        // grid plot in 0 and 1 array
        let grid_plot = usStateMatrix[i][s];

        // if we have a plot in the grid
        if (grid_plot !== 0) {
          // get the state
          //let state = mapData[state_index];
          let state = usStateData[state_index];
          let colorClass = '';
          // create the hex group
          let hexGroup = createHexagon(
            svg,
            loc_x + loop_x,
            y,
            y + 20,
            hex_rad,
            state,
            //width,
            displayPercent
          );
          if(parseFloat(state.yAxis) < 11 ){
            colorClass = 'statistics-legend-0'
          } else if(parseFloat(state.yAxis) > 10 && parseFloat(state.yAxis) < 21){
            colorClass = 'statistics-legend-1-3';
          } else if(parseFloat(state.yAxis) > 20 && parseFloat(state.yAxis) < 31){
            colorClass = 'statistics-legend-4-8';
          } else if(parseFloat(state.yAxis) > 30 && parseFloat(state.yAxis) < 41){
            colorClass = 'statistics-legend-9';
          } else if(parseFloat(state.yAxis) > 40 && parseFloat(state.yAxis) < 51){
            colorClass = 'statistics-legend-10';
          } else if(parseFloat(state.yAxis) > 50 && parseFloat(state.yAxis) < 61){
            colorClass = 'statistics-legend-11';
          } else {
            colorClass = 'statistics-legend-12';
          } 
          hexGroup.setAttribute('class', `${colorClass}`);
          
          // have to reappend element on hover for stacking  
          hexGroup.addEventListener('mouseenter', function (e) {
           previousElement=this.previousSibling
            this.setAttribute(
              'class',
              `${colorClass} hexagon-hover statistics-hexagon-hover`
            );
            this.children[1].style.opacity = 0;
            this.children[3].style.opacity = 1;
            this.remove();
            svg.append(this);
          });
          
          // clear class
          hexGroup.addEventListener('mouseleave', function () {
            const elements = document.querySelectorAll('.statistics-hexagon-hover');
            elements.forEach((element) => {
              element.classList.remove('statistics-hexagon-hover');
              element.classList.remove('hexagon-hover');
              element.children[0].classList.remove('focus');
              element.children[1].style.opacity = 1;
              element.children[3].style.opacity = 0;
            });
            this.setAttribute('class', `${colorClass}`);
            this.children[1].style.opacity = 1;
            this.children[3].style.opacity = 0;
            if(previousElement !== null){
              previousElement.after(svg.lastChild);
            }
            if(previousElement === null){
              svg.prepend(svg.lastChild)
            }
          });

          document.body.addEventListener('keydown', function(e) { 
            if (e.key !== 'Tab' ) {
              return 
            }
            const elements = document.querySelectorAll('.statistics-hexagon-hover');
            elements.forEach((element) => {
              element.classList.remove('statistics-hexagon-hover');
              element.classList.remove('hexagon-hover');
              element.children[0].classList.remove('focus');
              element.children[1].style.opacity = 1;
              element.children[3].style.opacity = 0;
            });
            if(currentElement?.children[1].innerHTML === "PR") { 
              document.querySelectorAll(".statistics-btn")[rest.mapIDValue].focus()
              e.preventDefault();
              currentElement = null;  
            }
          })
          
          hexGroup.addEventListener('focus', function(){
            previousElement=this.previousSibling;
            currentElement = this;
            this.remove();
            svg.append(this);
            this.setAttribute(
              'class',
              `${colorClass} hexagon-hover statistics-hexagon-hover`
            );
            this.children[0].setAttribute('class', 'focus')
            this.children[1].style.opacity = 0;
            this.children[3].style.opacity = 1;
          });

        hexGroup.addEventListener('blur', function () {
          const elements = document.querySelectorAll('.statistics-hexagon-hover');
          elements.forEach((element) => {
            element.classList.remove('statistics-hexagon-hover');
            element.classList.remove('hexagon-hover');
            element.children[0].classList.remove('focus');
            element.children[1].style.opacity = 1;
            element.children[3].style.opacity = 0;
          });
        });
        
        // append the hex to our svg
        svg.appendChild(hexGroup)
        // increase the state index reference
        state_index++;
      }
        // move our x plot to next hex position
        loc_x += hex_apo * 2;
      }
      // move our y plot to next row position
      y += hex_di * 0.75;
      // toggle offset per row
      offset = !offset;
    }
  }

  useEffect(() => {
    if (svg) {
      container.current.appendChild(svg);
    }
  }, [rows]);
  
  return (
    <>
      <div
        className="desktop:display-block mobile:display-none statistics-hexagon-map-hover"
        id={rest.mapID}
        ref={container}
      >
      </div>
    </>
  );
};
export default StatisticsHexagonMap;